import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    fetchProductList,
    setProductAccess,
    fetchAccountAccess,
    setAccountAccess,
    createAccountAccess,
    fetchUserCache,
    expireUserCache,
} from '../../actions/admin-actions';
import { fetchEventLabs, setEventId } from '../../actions/event-actions';
import { fetchLabItems, fetchProducts, findLabsByProduct, clearLabDetails } from '../../actions/lab-actions';
import { setStudentId, fetchStudentLabs, findUserLabs, findFilteredStudentLabs } from '../../actions/student-actions';

import Home from './home';

// Select only the slices the Home sub-tree reads. Returning the whole store
// (`(reducers) => reducers`) forwarded unused slices (accountReducer, routing)
// and re-rendered Home on every unrelated state change.
const mapStateToProps = ({ appReducer, adminReducer, labReducer, eventReducer, studentReducer }) => ({
    appReducer,
    adminReducer,
    labReducer,
    eventReducer,
    studentReducer,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchProductList,
            setProductAccess,
            fetchAccountAccess,
            setAccountAccess,
            createAccountAccess,
            clearLabDetails,
            fetchLabItems,
            fetchProducts,
            setEventId,
            fetchEventLabs,
            setStudentId,
            fetchStudentLabs,
            findLabsByProduct,
            findUserLabs,
            findFilteredStudentLabs,
            fetchUserCache,
            expireUserCache,
        },
        dispatch,
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
